export const getAuthProps = (state) => state.auth.authProps;
//# sourceMappingURL=auth.selector.js.map